import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import {jsonUrl,today,getTerms} from '../components/Factory' 
import KalenderList from '../components/KalenderList'; 
import {UISref} from 'ui-router-react'; 
import KalenderAnmelden from '../components/KalenderAnmelden'; 
import Flexbox from '../components/misc/Flexbox'; 

class KalenderContainer extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  kalenderItems: this.props.resolves.kalenderItems,
		  offset : 16,
		  kategory: this.props.resolves.kategory,
		  finished:'block',
		  anmelden:'',
		  kalenderName:'', 
		  kalenderDate:''
		}
		this.onChange = this.onChange.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}
	handleOpen(data){
		this.setState({
			anmelden:'open',
			kalenderName:data[0],
			kalenderDate:data[1],
			perform:data[2],
			type:data[3],
			kalenderTime:data[4]
		});
		document.body.classList.toggle('no-scroll');
	}
	handleClose(){
		this.setState({
			anmelden:''
		});
		document.body.classList.toggle('no-scroll');
	}
	onChange(isVisible){
		if(isVisible) { 
			this.loadMore();
		}
	}	
	loadMore(){
		let tax_query = '',cat = this.state.kategory;
		if(cat!==''){
			tax_query = '&filter[tax_query][0][taxonomy]=kalender-kategorie&filter[tax_query][0][field]=slug&filter[tax_query][0][terms]='+cat;
		}
		fetch(jsonUrl({ 	number:16,
							offset:this.state.offset,
							type:'kalender',
							meta_key:"event_start_date", 
							orderbymeta:'meta_value',
							meta_type:'date',
							order:'asc',
							meta_query:'&filter[meta_query][0][0][key]=event_start_date&filter[meta_query][0][0][value]='+today()+'&filter[meta_query][0][0][compare]=>=&filter[meta_query][0][0][type]=date&filter[meta_query][0][1][key]=event_end_date&filter[meta_query][0][1][value]='+today()+ '&filter[meta_query][0][1][compare]=>=&filter[meta_query][0][1][type]=date&filter[meta_query][0][relation]=OR'+tax_query
						}))
					  .then(res => res.json())
					  .then(res => {
							let sdata =  res.sort((a,b)=>{ return a.kalender_date - b.kalender_date });	
							if(sdata.length>0)
								this.setState({
									kalenderItems: [...this.state.kalenderItems,...sdata],
									offset: this.state.offset+6
								});
							else
								this.setState({
									finished:'none'
								});
					  })
	}
	componentDidMount(){	
		setTimeout(function(){
			document.getElementById('menu-programm').classList.add('active');
		},400);
	}
	componentWillUnmount(){
		document.getElementById('menu-programm').classList.remove('active');
	}
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	render() {		   
		   const {kategories,page,staticData} = this.props.resolves;
		   return (
				<div>
					{
					(this.state.kategory==='')?
					<div className="container-fluid lg-side-padding">
						<ul aria-label="Kategory List" className="categories-menu">
							<li className="selected">Alle</li>
							{
								kategories.map( (data,i)=> {
									if(data.event_count>0){
										return (
												<UISref key={i} to="root.programm.kalender-kategorie.name" params={{item:data.slug}} >
													<li>
														<a href="">{data.name}</a>
													</li>
												</UISref>
										)
									}
									else
										return '';
									
								})
							}						
						</ul>
						<Flexbox left={page.title_left} right={page.title_right} /> 	
					</div>: <div></div>
					}
					<div className="container-fluid lg-side-padding kalendar-page">
						<div className="row">            
							<div className="col-md-12">								
								<KalenderList staticData={staticData} handleClick={this.handleOpen} data={this.state.kalenderItems} /> 
								<VisibilitySensor onChange={this.onChange}>
									<div className="loading small" style={{display:this.state.finished}}>
										<div className="one"></div>			
									</div>
								</VisibilitySensor>
							</div>
						</div>
					</div>
					
					<KalenderAnmelden staticData={staticData}  {...page} eventdate={this.state.kalenderDate} kalender={this.state.kalenderName} handleClick={this.handleClose} kalenderTime={this.state.kalenderTime} perform={this.state.perform} formType={this.state.type} status={this.state.anmelden} />
				</div>
			)
	   
	}
}
export function getPage(name,parent){
	if(parent!=null){
		return fetch(jsonUrl({ 
						number:1,
						type:'pages',
						slug:parent
					}))
				  .then(res => res.json())
				  .then(res => {
						return fetch(jsonUrl({ 
								number:1,
								type:'pages',
								slug:name,
								post_parent:res[0].id
						}))
						.then(res => res.json())
						.then(res => {
							document.title = res[0].yoast.title
							return res[0];		 
						}) 
				  })
	}
	else
		return fetch(jsonUrl({ 
						number:1,
						type:'pages',
						slug:name
					}))
				  .then(res => res.json())
				  .then(res => {
					document.title = res[0].yoast.title
					return res[0];		 
				  })
}
export function getKategories(name){
	return fetch(getTerms(name)).then(res => res.json())
				  .then(res => {
					return res;		 
				  })
}
export function getkalenderItems(cat){
	let tax_query = '';
	if(cat!==''){
		tax_query = '&filter[tax_query][0][taxonomy]=kalender-kategorie&filter[tax_query][0][field]=slug&filter[tax_query][0][terms]='+cat;
	}
	 
	return fetch(jsonUrl({ 
						number:16,
						type:'kalender',
						meta_key:"event_start_date",
						orderbymeta:'meta_value',
						meta_type:'date',
						order:'asc',
						meta_query:'&filter[meta_query][0][0][key]=event_start_date&filter[meta_query][0][0][value]='+today()+'&filter[meta_query][0][0][compare]=>=&filter[meta_query][0][0][type]=date&filter[meta_query][0][1][key]=event_end_date&filter[meta_query][0][1][value]='+today()+ '&filter[meta_query][0][1][compare]=>=&filter[meta_query][0][1][type]=date&filter[meta_query][0][relation]=OR'+tax_query
					}))
				  .then(res => res.json())
				  .then(res => {
					return res.sort((a,b)=>{ return a.kalender_date - b.kalender_date });		 
				  })
}
export default KalenderContainer;


// WEBPACK FOOTER //
// ./src/containers/KalenderContainer.js